var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, } from 'react';
import './HomepageHeroAccordion.scss';
import Arrow from '../../assets/images/HomepageHero/arrow.png';
import Collapse from '../../assets/images/HomepageHero/collapse.png';
import { Button } from '../../components/CtaButtons';
var HomepageHeroAccordion = function (_a) {
    var homepage_data = _a.data.homepage_data;
    var _b = useState(0), selected = _b[0], setSelected = _b[1];
    var _c = useState(0), value = _c[0], setValue = _c[1];
    var toggle = function (i) {
        if (selected == i) {
            return setSelected(-1);
        }
        setValue(0);
        setSelected(i);
    };
    var seconds = 0;
    useEffect(function () {
        function openNextItem() {
            var i = selected === homepage_data.hero_items.length - 1 ? 0 : selected + 1;
            setSelected(i);
        }
        var interval = setInterval(function () {
            seconds = seconds + 0.25;
            setValue(seconds);
            if (seconds == 7) {
                setValue(0);
                clearInterval(interval);
                openNextItem();
            }
        }, 250);
        if (selected === -1) {
            clearInterval(interval);
            setValue(0);
        }
        return function () { return clearInterval(interval); };
    }, [selected, homepage_data.hero_items.length]);
    return (_jsxs("div", __assign({ className: "w-full snap-start bg-no-repeat overflow-visible homepage-hero-image-container-accordion accordion-item-" + (selected !== -1 ? selected : 'closed') }, { children: [_jsx("div", __assign({ className: "homepage-hero-accordion-wrapper" }, { children: _jsx("div", __assign({ className: "homepage-hero-accordion" }, { children: homepage_data.hero_items.map(function (item, i) {
                        return (_jsxs("div", __assign({ className: "homepage-hero-accordion-item " + (selected == i ? 'active' : '') }, { children: [_jsxs("div", __assign({ className: "homepage-hero-accordion-title", onClick: function () {
                                        toggle(i);
                                    } }, { children: [_jsxs("div", { children: [_jsxs("span", __assign({ className: "homepage-hero-accordion-title-index" }, { children: [0, i + 1] }), void 0),
                                                _jsx("span", { className: "homepage-hero-accordion-space" }, void 0),
                                                _jsx("span", __assign({ className: "homepage-hero-accordion-item-title" }, { children: item.title }), void 0)] }, void 0),
                                        _jsx("span", __assign({ className: "homepage-hero-accordion-toggle" }, { children: selected === i ? (_jsx("img", { src: Collapse, alt: "close accordion button" }, void 0)) : (_jsx("img", { src: Arrow, alt: "open accordion button" }, void 0)) }), void 0)] }), void 0),
                                _jsxs("div", __assign({ className: "homepage-hero-accordion-blog " + (selected === i ? 'show' : '') }, { children: [_jsx("div", __assign({ className: "homepage-hero-accordion-blog-heading" }, { children: item.head_line }), void 0),
                                        _jsx("div", __assign({ className: "homepage-hero-accordion-blog-description" }, { children: item.body }), void 0),
                                        item.cta_link && item.cta_copy && (_jsx("a", __assign({ className: "homepage-hero-accordion-blog-cta-link", href: item.cta_link }, { children: _jsx(Button, __assign({ classes: [
                                                    'text-enblue-500',
                                                    'focus:bg-enblue-light',
                                                    'ArticleButtons_custom',
                                                    'homepage-hero-accordion-cta-button',
                                                ], animate: "animate-white" }, { children: _jsx("div", __assign({ className: "homepage-hero-accordion-blog-cta text-enblue-500", style: { zIndex: 1 } }, { children: item.cta_copy }), void 0) }), void 0) }), void 0))] }), void 0),
                                selected == i ? (_jsx("div", __assign({ className: "homepage-hero-accordion-progress-bar" }, { children: _jsx("div", { className: "homepage-hero-accordion-progress", style: { width: (100 / 6) * value + "%" } }, void 0) }), void 0)) : (_jsx("div", __assign({ className: "homepage-hero-accordion-progress-bar" }, { children: _jsx("div", { className: "homepage-hero-accordion-progress no-timer", style: { width: 0 + "%" } }, void 0) }), void 0))] }), i));
                    }) }), void 0) }), void 0),
            _jsx("div", { className: "homepage-hero-accordion-background-overlay" }, void 0),
            homepage_data.hero_items.map(function (item, i) { return (_jsx("img", { className: "homepage-hero-accordion-background-images background-accordion-image-" + i, src: item.bg_image, alt: item.title + "-background-image" }, i)); })] }), void 0));
};
export default HomepageHeroAccordion;
